module.exports = __webpack_public_path__ + "img/18_44.10c71f78.png";